import { useState } from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

import { TAGS_STYLES } from './helpers'
import MenuCustomOption from './components/MenuCustomOption'
import MenuNoOptionsMessage from './components/MenuNoOptionMessage'

const FormFieldTags = ({
  name,
  onChange,
  label,
  value,
  options,
  isError,
  errorLabel,
  placeholder,
  maxTagsCount,
  maxTagLength,
  ...props
}) => {
  const [newOption, setNewOption] = useState('')

  const isAtMax = Boolean(maxTagsCount) && value.length >= maxTagsCount

  const handleAddOption = (newTag) => {
    if (isAtMax) return
    const isNewTagAlreadyAdded = value.find((option) => option.label === newTag)
    if (newTag && !isNewTagAlreadyAdded) {
      const newOption = { value: newTag, label: newTag }
      onChange(name, [...value, newOption])
      setNewOption('')
    }
  }

  const handleInputChange = (value) => {
    if (value.length > maxTagLength) return
    setNewOption(value)
  }

  const handleChange = (tags) => {
    if (maxTagsCount && tags.length > maxTagsCount) return
    onChange(name, tags)
  }

  const onEnterPressed = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (e.target.value) {
        handleAddOption(e.target.value)
      }
    }
  }

  return (
    <div className="form-field-tags">
      {label && (
        <label htmlFor={name} className="label">
          {label}
        </label>
      )}
      <div>
        <Select
          {...props}
          className="form-field-tags-select"
          classNamePrefix="my-select"
          autosize={true}
          onInputChange={handleInputChange}
          inputValue={newOption}
          options={options}
          onChange={handleChange}
          value={value}
          closeMenuOnSelect={false}
          components={{
            DropdownIndicator: null,
            NoOptionsMessage: (props) => (
              <MenuNoOptionsMessage {...props} handleAddOption={handleAddOption} />
            ),
            Option: MenuCustomOption,
          }}
          placeholder={placeholder}
          isMulti
          hideSelectedOptions={false}
          styles={TAGS_STYLES}
          onKeyDown={onEnterPressed}
        />
      </div>
      {isAtMax && (
        <span className="form-field-tags__max-message">
          {`A maximum of ${maxTagsCount} tags can be assigned.`}
        </span>
      )}
      {errorLabel && isError && <span className="label--error">{errorLabel}</span>}
    </div>
  )
}

FormFieldTags.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  additionalClass: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  min: PropTypes.number,
  isError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errorLabel: PropTypes.string,
  style: PropTypes.object,
  options: PropTypes.array,
  maxTagsCount: PropTypes.number,
  maxTagLength: PropTypes.number,
}

FormFieldTags.defaultValue = {
  isError: false,
  type: 'text',
}

export default FormFieldTags
